import { render, staticRenderFns } from "./KonvaCampaignImage.vue?vue&type=template&id=284de6b9"
import script from "./KonvaCampaignImage.vue?vue&type=script&lang=js"
export * from "./KonvaCampaignImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports